import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";

import {MultiSelect,
    DropDownList
} from '@syncfusion/ej2-dropdowns';
import {
    loadCldr,
    L10n,
    setCulture,
    registerLicense
} from '@syncfusion/ej2-base';


registerLicense('License key');
import {
    fr
} from '@syncfusion/ej2-locale/src/fr.json';
import {
    Day,
    Week,
    WorkWeek,
    Month,
    Schedule,
    DragAndDrop,Resize
} from '@syncfusion/ej2-schedule';
setCulture('fr');
// Injecter les vues nécessaires dans le Scheduler
Schedule.Inject(Day, Week, WorkWeek, Month, DragAndDrop,Resize);

registerLicense("ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Xd0xjXXtYcXdUTmFc");

// Charger les fichiers de localisation
loadCldr(require('../cldr-data/main/fr/ca-gregorian.json'));
loadCldr(require('../cldr-data/main/fr/ca-generic.json'));
loadCldr(require('../cldr-data/main/fr/timeZoneNames.json'));
loadCldr(require('../cldr-data/main/fr/dateFields.json'));
loadCldr(require('../cldr-data/main/fr/numbers.json'));
loadCldr(require('../cldr-data/main/fr/numberingSystems.json'));

// Appliquer les fichiers de localisation pour la langue française
L10n.load({
    'fr': fr
});



export default class extends ApplicationController {

    static targets = ["hm0_output"];


    connect() {




        console.log("CompteRendu JS en cours ...");

        console.log("Current app", this.current_app);

        super.connect();
        StimulusReflex.register(this);

        if (
            $("#scheduler")
        ) {
            //on est sur le show
            ////scheduler.showSpinner();
            this.loadScheduler();



        }


        if ($("#search").length && $("#quick_sort").length) {

            this.rerender();
            (function($) {
                $.each(["show", "hide"], function(i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function() {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function() {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function() {
                $("#total_entries").show();
            });

            $("#mySidebar #table_custom_ .switch input").each(function() {
                let me = $(this);
                if (
                    me.attr("type") === "checkbox" &&
                    me.attr("class").includes("preference_columns")
                ) {
                    me[0].addEventListener("change", (e) => {
                        let hiddenHtmlClass = e.target.id.replace("filterrific_", "");
                        console.log(hiddenHtmlClass);
                        if (e.target.checked) {
                            console.log("show ", e.target);
                            $("." + hiddenHtmlClass).show();
                        } else {
                            console.log("hide ", e.target);
                            $("." + hiddenHtmlClass).hide();
                        }
                    });
                }
            });
            /////


            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                document.getElementById("scrollevel").value = element.scrollTop;
            });

            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const compteRenduParam = url.searchParams.get("previous_record");

            if (compteRenduParam != null) {
                var trElement = $("#compte_rendu_" + compteRenduParam);
                $("#compte_rendu_" + compteRenduParam + " td").addClass("highlighted-td");
                $("#compte_rendu_" + compteRenduParam).get(0).scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        }
    }


   async loadScheduler() {

        var eventsContainer = document.getElementById('events_data_container');
        var jsonData = eventsContainer ? eventsContainer.getAttribute('data-compte-rendu-eventjson') : null;

        if (jsonData) {
            console.log("jsonData est bien défini", jsonData);
            var parsedData = JSON.parse(jsonData);

            if (this.current_app) {
                //console.log(parsedData);
                this.eventsData = parsedData;
                this.initializeScheduler(this.eventsData, this.current_app).then((sche)=>{

                 this.scheduler = sche;


                 console.log("La réponse de de initializeScheduler ::> ",sche);
                 console.log("La réponse de de initializeScheduler ::> ",this.scheduler);


                 this.scheduler.eventSettings.dataSource = this.eventsData;
                 let selectedDateParam =this.getParameterByName("filterrific[with_pf_date_heure_debut_inf]");
                 //let currentView =this.getParameterByName("filterrific[current_view]");


                 console.log("selectedDateParam selectedDateParam ");
                 console.log("selectedDateParam selectedDateParam ");
                 console.log("selectedDateParam selectedDateParam ");
                 console.log("selectedDateParam selectedDateParam ",selectedDateParam);
                 console.log("selectedDateParam selectedDateParam ");
                 console.log("selectedDateParam selectedDateParam ");
                 this.scheduler.selectedDate = selectedDateParam ?? new Date();
                // this.scheduler.currentView = currentView ?? "Week";

                 this.scheduler.refreshing = true;
                 });

            } else {
                console.log("Pas de current_app ");
            }
        } else {
            console.error("Aucune donnée d'événement trouvée !");
        }
    }


    convertDate(inputDate) {
        const dateObject = new Date(Date.parse(inputDate));
        const formattedDate = dateObject.toISOString().replace(/[-:.]/g, '').replace(/[TZ]/g, 'Z');
        return formattedDate;
    }

    eventToCompteRendu(event) {

        console.log("event");
        console.log(event?.RecurrenceException);
        console.log(event);
        console.log("event");

        let compte_rendu = {
            id: event?.Id,
            compte_rendu_id: event?.Id,
            objet: event?.Object,
            date_heure_debut: event?.StartTime,
            date_heure_fin: event?.EndTime,
            adresse: event?.Location,
            detail: event?.Description,
            contact_id: event?.ContactId,
            contacts: event?.Contacts,
            contact2_id: event?.Contact2Id || parseInt(self.contact2_id),
            recurrence_rule: event?.RecurrenceRule,
            start_timezone: event?.StartTimezone,
            end_timezone: event?.EndTimezone,
            journee_entiere: this.boolToInt(event?.IsAllDay),
            recurrence_exception: event?.RecurrenceException,
        };


        console.log("RecurrenceException est peut-être dedans:", compte_rendu);
        console.log("RecurrenceException est peut-être dedans:", compte_rendu.recurrence_exception);




        return compte_rendu;
    }

    intToBool(val) {
        switch (val) {
            case 1:
                return true;
            case 2:
                return false;
            default:
                return false;
        }
    }

    boolToInt(boolValue) {
        return boolValue ? 1 : 2;
    }

    httpGet(url, params) {
        // Si des paramètres sont fournis, générez une chaîne de requête à partir de ceux-ci
        if (params) {

            const queryString = Object.keys(params?.filterrific)
                .map(key => encodeURIComponent(`filterrific[${key}]`) + '=' + encodeURIComponent(params?.filterrific[key]))
                .join('&');
            url += '?' + queryString;
        }

        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, false); // Utilisez la valeur false pour effectuer une requête synchrone
        xhr.send(null);
        return xhr.responseText;
    }

    getCurrentMonthParams() {
        // Obtention de la date d'aujourd'hui
        var today = new Date();

        // Obtention du premier jour du mois
        var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // Obtention du dernier jour du mois
        var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        // Formatage des dates au format ISO 8601
        var startDate = firstDayOfMonth.toISOString();
        var endDate = lastDayOfMonth.toISOString();

        // Création de l'objet params
        var params = {
            filterrific: {
                with_pf_date_heure_debut_inf: startDate,
                with_pf_date_heure_fin_sup: endDate,
                with_pf_recurrence: "recurrence_rule"
            }
        };

        // Renvoi de l'objet params
        return params;
    }



    getCurrentWeekParams() {
        // Obtention de la date d'aujourd'hui
        var today = new Date();

        // Obtention du jour de la semaine (0 pour dimanche, 1 pour lundi, ..., 6 pour samedi)
        var dayOfWeek = today.getDay();

        // Calcul du décalage pour obtenir le début de la semaine (dimanche)
        var startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - dayOfWeek);

        // Calcul du décalage pour obtenir la fin de la semaine (samedi)
        var endOfWeek = new Date(today);
        endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));

        // Formatage des dates au format ISO 8601
        var startDate = startOfWeek.toISOString();
        var endDate = endOfWeek.toISOString();

        // Création de l'objet params
        var params = {
            filterrific: {
                with_pf_date_heure_debut_inf: startDate,
                with_pf_date_heure_fin_sup: endDate,
                with_pf_recurrence: "recurrence_rule"
            }
        };

        // Renvoi de l'objet params
        return params;
    }



 numberToHexColor(number) {
    // Limiter la plage des valeurs RVB pour éviter des couleurs trop sombres ou trop claires
    var red = (number % 128) + 128; // Rouge dans la plage 128-255
    var green = ((number >> 8) % 128) + 128; // Vert dans la plage 128-255
    var blue = ((number >> 16) % 128) + 128; // Bleu dans la plage 128-255

    // Convertir les valeurs RVB en une couleur hexadécimale
    var hex = ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1);

    // Préfixer avec '#' pour obtenir une couleur hexadécimale valide
    return "#" + hex;
}






     getParameterByName (parameter, url) {
                           // Utilise l'URL du navigateur par défaut si aucun URL n'est fourni
                           if (!url) {
                               url = window.location.href;
                           }

                           // Analyse l'URL pour extraire les paramètres
                           var urlParams = new URLSearchParams(url.substring(url.indexOf("?") + 1));

                           // Récupère la valeur du paramètre spécifié
                           var paramValue = urlParams.get(parameter);

                           return paramValue;
                       }

   async initializeScheduler(eventsData, current_app) {

        var self = this; // Stocker la référence au contexte this

        var schedulerElement = document.getElementById('scheduler');

        if (!schedulerElement) {
            console.error("Élément de planificateur introuvable !");
            return;
        } else {
            console.error("Élément de planificateur est là !");
        }


        console.log("scheduler",scheduler);
        var scheduler = await new Schedule({
            locale: this.local,
            width: '100%',
            height: '85vh',
            currentView: "Week",
            showHeaderBar: true,
            enablePersistence: true,
            allowDragAndDrop: true,
              workHours: {
                   highlight: true,
                   start: '09:00',
                   end: '18:00'
               },
                  startHour: "9",
                   endHour: "18",
            views: ["Day", "Week", "WorkWeek", "Month"],
            eventSettings: {
                dataSource: eventsData,
                fields: {
                    subject: {
                        name: 'Object',validation:{required:true}
                    }
                }
            }, eventRendered: function(args) {console.log("hellloe",args);args.element.style.backgroundColor = args.data.Color;

                        args.element.querySelector('.e-subject').innerText = args.data?.Sil;

                        // Supprimer l'affichage du lieu du rendez-vous
                        args.element.querySelector('.e-location').style.display = 'none';


            //args.element.innerText = args.data?.Sil;

            },
            navigating: async function(args) {

 $('.child-loader').show();
      console.log("Lg xxxxxxxx");

                        document.getElementById('child-loader').style.display = 'block';
                console.log("Agrs de la requeete", args);
                if (args.action === "date" || args.action === "view") {


                    // Récupérer le type de vue actuelle à partir de l'objet scheduler
                    var currentView = scheduler?.activeViewOptions?.option;

 try {
            // Récupérer les dates de début et de fin en fonction de la vue actuelle

                    // Définir la date de début et de fin en fonction du type de vue
                    var startDate, endDate;
                    switch (currentView) {
                        case "Day":
                            startDate = args.currentDate;
                            endDate = new Date(startDate);
                            endDate.setDate(endDate.getDate() + 1); // Fin de la journée
                            break;
                        case "Week":
                        case "WorkWeek":
                            startDate = new Date(args.currentDate);
                            while (startDate.getDay() !== 1) { // Trouver le début de la semaine
                                startDate.setDate(startDate.getDate() - 1);
                            }
                            endDate = new Date(startDate);
                            endDate.setDate(endDate.getDate() + 7); // Fin de la semaine
                            if (currentView === "WorkWeek") {
                                // Si c'est une vue WorkWeek, ajuster pour ne montrer que les jours ouvrables
                                while (startDate.getDay() === 0 || startDate.getDay() === 6) {
                                    startDate.setDate(startDate.getDate() + 1);
                                }
                                while (endDate.getDay() === 0 || endDate.getDay() === 6) {
                                    endDate.setDate(endDate.getDate() - 1);
                                }
                            }
                            break;
                        case "Month":
                            startDate = new Date(args.currentDate.getFullYear(), args.currentDate.getMonth(), 1);
                            endDate = new Date(args.currentDate.getFullYear(), args.currentDate.getMonth() + 1, 0);
                            endDate.setDate(endDate.getDate() + 1); // Fin du mois
                            break;
                        default:
                            // Gérer les vues non prises en charge ici
                            break;
                    }

                    // Utilisez startDate et endDate comme vous le souhaitez, par exemple, affichez-les dans la console
                    console.log("Date de début de la vue:", startDate);
                    console.log("Date de fin de la vue:", endDate);


                    var params = {
                        filterrific: {

                            with_pf_date_heure_debut_inf: startDate,
                            with_pf_date_heure_fin_sup: endDate,
                            with_pf_recurrence: "recurrence_rule"
                        }
                    };


                    console.log("L'attribut 'data-compte-rendu-eventjson' n'est pas défini ou est null.");
                    // Effectuez une requête HTTP GET pour récupérer les données JSON de manière synchrone
                    self.eventsData = await JSON.parse(self.httpGet(self.current_app + "/compte_rendus/calendar.json", params));
                    console.log("Données d'événement récupérées :", self.eventsData);
                    scheduler.eventSettings.dataSource = self.eventsData;


                     } catch (error) {
                                console.error("Une erreur s'est produite lors de la récupération des données des événements :", error);
                                // Gérer les erreurs de récupération des données ici si nécessaire
                            } finally {
                                       setTimeout(function() {
                                                       document.getElementById('child-loader').style.display = 'none';
                                                   }, 50);
                            }
                }
            },
            dataBound: function (){
            setTimeout(function() {
                       document.getElementById('child-loader').style.display = 'none';
                   }, 50);

            },
            actionBegin: function(args) {
            //scheduler.showSpinner();

                    requestAnimationFrame(function() {
                      console.log("LOg requestAnimationFrame");
                      $('.child-loader').show();
                        document.getElementById('child-loader').style.display = 'block';
                    });

                var event_args = args;
                // Empêcher le rechargement des données lors de la navigation
                if (args.requestType === 'toolbarItemRendering') {
                    args.cancel = true;
                }

                if (args.requestType === "dateNavigate") {
                    // Récupérer la date de début de la vue actuelle
                    var startDate = args?.currentView?.startDate;

                    // Récupérer la date de fin de la vue actuelle
                    var endDate = args?.currentView?.endDate;

                    // Utilisez startDate et endDate comme vous le souhaitez, par exemple, affichez-les dans la console
                    console.log("Date de début de la vue:", startDate);
                    console.log("Date de fin de la vue:", endDate);
                }
                console.log("args");
                console.log(event_args);
                console.log("args");

                if (args.requestType === 'eventCreate' || args.requestType === 'eventChange' || args.requestType === 'eventRemove') {
                    // L'action est "Save" lorsqu'un événement est créé ou modifié
                    // Insérez votre logique de sauvegarde ou de traitement des données ici
                    console.log('Action "Save" completed ----> ');
                    console.log(args);
                    // Fermez le modal après avoir traité les données si nécessaire
                }


                if (args.requestType === 'eventChange') {
                    let eventData = args?.changedRecords[0];

                    // Effectuer une requête AJAX pour mettre à jour l'événement
                    let compte_rendu = self.eventToCompteRendu(eventData);

                    // Fonction asynchrone pour mettre à jour l'événement
                    async function updateEvent() {
                        try {
                            const response = await $.ajax({
                                url: current_app + '/compte_rendus/update_event',
                                method: 'PATCH',
                                data: {
                                    compte_rendu_id: eventData.Id,
                                    compte_rendu: compte_rendu
                                }
                            });

                            console.log('Event updated successfully:', response.message);
                            let selectedIndex = self.eventsData.findIndex(event => event.Id === eventData?.Id);
                            if (selectedIndex !== -1) {
                                console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                                self.eventsData.splice(selectedIndex, 1);
                                self.eventsData.push(response.data);
                                self.scheduler.eventSettings.dataSource = self.eventsData;
                                console.log(self.eventsData);
                                self.scheduler.refresh();
                            } else {
                                console.error('Événement sélectionné non trouvé dans eventsData.');
                            }
                        } catch (error) {
                            console.log('Error updating event:', error);
                            // Gérer les erreurs ici si nécessaire
                            if (error.status) {

                                compte_rendu.recurrence_rule = "";
                                compte_rendu.recurrence_exception = "";
                                compte_rendu.compte_rendu_id = "";
                                // Fonction asynchrone pour créer un nouvel événement
                                async function createEvent() {
                                    try {
                                        const response = await $.ajax({
                                            url: current_app + '/compte_rendus/create_event',
                                            method: 'POST',
                                            data: {
                                                compte_rendu_id: compte_rendu.id,
                                                compte_rendu: compte_rendu
                                            }
                                        });

                                        console.log('Event created successfully:', response);
                                        self.eventsData.push(response.data);
                                        scheduler.eventSettings.dataSource = self.eventsData;

                                    } catch (error) {
                                        console.error('Error create event:', error);
                                        // Gérer les erreurs ici si nécessaire
                                    }finally {
                                                                                                           setTimeout(function() {
                                                                                                                           $('.child-loader').hide();
                                                                                                                       }, 50);
                                                                                                }
                                }

                                // Appeler la fonction pour créer un nouvel événement

                                await createEvent();

                                // Récupérer le parent de l'événement modifié
                                var parentEventData = self.eventToCompteRendu(args?.data?.parent);
                                console.log("Le compterent parent", parentEventData);

                                // Effectuer une requête AJAX pour mettre à jour le parent
                                try {
                                    const response = await $.ajax({
                                        url: current_app + '/compte_rendus/update_event',
                                        method: 'PATCH',
                                        data: {
                                            compte_rendu_id: parentEventData?.id,
                                            compte_rendu: parentEventData
                                        }
                                    });

                                    console.log('Parent updated successfully:', response);
                                    let selectedIndex = self.eventsData.findIndex(event => event.Id === eventData?.Id);
                                    let parentIndex = self.eventsData.findIndex(event => event.Id === parentEventData?.id);
                                    if (selectedIndex !== -1) {
                                        console.log('Index du parent de l\'événement sélectionné dans eventsData :', parentIndex);
                                        self.eventsData[parentIndex] = response.data;
                                        scheduler.eventSettings.dataSource = self.eventsData;
                                        //scheduler.refreshEvents();
                                    } else {
                                        console.error('Événement sélectionné non trouvé dans eventsData.');
                                    }
                                    if (selectedIndex !== -1) {
                                        console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                                        self.eventsData.splice(selectedIndex, 1);
                                        scheduler.eventSettings.dataSource = self.eventsData;
                                        //scheduler.refreshEvents();
                                    } else {
                                        console.error('Événement sélectionné non trouvé dans eventsData.');
                                    }
                                } catch (error) {
                                    console.error('Error updating parent event:', error);
                                    // Gérer les erreurs ici si nécessaire
                                }
                            }
                        }finally {
                                                                      setTimeout(function() {
                                                                                      $('.child-loader').hide();
                                                                                  }, 50);
                                                           }
                    }

                    // Appeler la fonction pour mettre à jour l'événement
                    updateEvent().then(() => {
                        scheduler.refreshEvents();
                    }).catch(error => {
                        console.error('Error during event update:', error);
                        // Gérer les erreurs ici si nécessaire
                    });


                }


                if (args.requestType === 'eventCreate') {


                    console.log(args);
                    let eventData = args?.data[0];
                    let compte_rendu = self.eventToCompteRendu(eventData);

                    console.log(args);
                    $.ajax({
                        url: current_app + '/compte_rendus/create_event',
                        method: 'POST', // Utilisez PATCH pour les mises à jour partielles
                        data: {
                            compte_rendu_id: eventData?.Id,
                            compte_rendu: compte_rendu // Envoyez les données de l'événement modifié au serveur
                        },
                        success: function(response) {
                            console.log('Event created successfully:', response);
                            let selectedIndex = eventsData.findIndex(event => event.Id === eventData?.Id);
                            if (selectedIndex !== -1) {
                                console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                                self.eventsData[selectedIndex] = response.data;
                                scheduler.eventSettings.dataSource = self.eventsData;
                                scheduler.refreshEvents();
                            } else {
                                console.error('Événement sélectionné non trouvé dans eventsData.');
                                let selectedIndex = eventsData.findIndex(event => event.Id === eventData?.Id);
                                self.eventsData.splice(selectedIndex, 1);
                                self.eventsData.push(response.data);
                                scheduler.eventSettings.dataSource = self.eventsData;
                                scheduler.refreshEvents();
                            }
                        },
                        error: function(xhr, status, error) {
                            console.error('Error create event:', status);
                            if (status == 404) {

                            }
                        }
                    });



                }

                if (args.requestType === 'eventRemove') {


                    if (event_args?.data[0]?.parent) {
                        let recurrence_exception = event_args?.data[0]?.parent.RecurrenceException + "," + self.convertDate(event_args?.data[0]?.occurrence.StartTime);

                        $.ajax({
                            url: current_app + '/compte_rendus/update_event',
                            method: 'PATCH', // Utilisez PATCH pour les mises à jour partielles
                            data: {
                                compte_rendu_id: event_args?.data[0]?.parent?.Id,
                                compte_rendu: {
                                    id: event_args?.data[0]?.parent?.Id,
                                    recurrence_exception: recurrence_exception
                                } // Envoyez les données de l'événement modifié au serveur
                            },
                            success: function(response) {
                                console.log('Event updated successfully:', response);
                                let selectedIndex = eventsData.findIndex(event => event.Id === event_args?.data[0]?.parent?.Id);
                                if (selectedIndex !== -1) {
                                    console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                                    self.eventsData[selectedIndex] = response.data;
                                    scheduler.eventSettings.dataSource = self.eventsData;
                                    console.log(self.eventsData);
                                } else {
                                    console.error('Événement sélectionné non trouvé dans eventsData.');
                                }
                            },
                            error: function(xhr, status, error) {
                                console.error('Error update event:', status);
                                if (status == 404) {

                                }
                            }
                        });


                    } else {

                        var eventData = args?.data[0];

                        $.ajax({
                            url: current_app + '/compte_rendus/' + eventData?.Id + '/delete_event',
                            method: 'DELETE',
                            success: function(response) {
                                console.log('Event deleted successfully:', response);
                                // Mettez à jour votre interface utilisateur ou effectuez d'autres actions si nécessaire
                                let selectedIndex = eventsData.findIndex(event => event.Id === eventData?.Id);
                                if (selectedIndex !== -1) {
                                    console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);

                                    // Supprimez l'événement de eventsData
                                    self.eventsData.splice(selectedIndex, 1);

                                    // Mettez à jour la source de données des événements dans le Scheduler et rafraîchissez la vue
                                    scheduler.eventSettings.dataSource = self.eventsData;
                                    scheduler.refreshEvents();
                                } else {
                                    console.error('Événement sélectionné non trouvé dans eventsData.');
                                }
                            },
                            error: function(xhr, status, error) {
                                console.error('Error deleting event:', status);
                                // Gérer les erreurs de suppression d'événement si nécessaire
                            }
                        });


                    }




                }
            },
            popupOpen: async function(args) {
                console.log(args);

              if (args.type === 'QuickInfo') {
                  args.element.querySelector('.e-subject').innerText = args.data?.Sil;
                  var popupContent = args.element.querySelector('.e-popup-content');

                  // Ajouter l'élément "Contact2" si Contact2Id est défini
                  if (popupContent && args.data?.Contact2Id && args.data?.Contact2?.text) {
                      var contact2Element = document.createElement('div');
                      contact2Element.classList.add('e-time-zone');
                      contact2Element.innerHTML = '<div class="e-people-icon e-icons"></div><div class="e-time-zone-details e-text-ellipsis">' + self.organisateur_label + ": " + args.data.Contact2.text + '</div>';
                      if (popupContent) {
                          popupContent.appendChild(contact2Element);
                      }
                  }

                  // Ajouter l'élément "Contact" si ContactId est défini
                  if (popupContent && args.data?.ContactId && args.data?.Contact?.text) {
                      var contactElement = document.createElement('div');
                      contactElement.classList.add('e-time-zone');
                      contactElement.innerHTML = '<div class="e-people-icon e-icons"></div><div class="e-time-zone-details e-text-ellipsis">' + self.contact_label + ": " + args.data.Contact.text + '</div>';
                      if (popupContent) {
                          popupContent.appendChild(contactElement);
                      }
                  }

                 // Ajouter l'élément "Contacts3" pour afficher tous les contacts sur la même ligne séparés par des virgules
                     if (popupContent && args.data?.Contacts3 && args.data?.Contacts3.length > 0) {
                         var contacts3Element = document.createElement('div');
                         contacts3Element.classList.add('e-time-zone');
                         var contacts3Text = args.data.Contacts3.map(contact => contact.nom + ' ' + contact.prenom).join(', ');
                         contacts3Element.innerHTML = '<div class="e-people-icon e-icons"></div><div class="e-time-zone-details e-text-ellipsis">' + self.participants_label +': ' + contacts3Text + '</div>';
                         if (popupContent) {
                             popupContent.appendChild(contacts3Element);
                         }
                     }




              }


                if (args.type === 'Editor') {
                    // Create required custom elements in initial time
                 /*   args.element.querySelector('.e-subject').setAttribute('name', 'Object');


                    let titleElement = args.element.querySelector('.e-subject');
                    if (titleElement) {
                        titleElement.setAttribute('value', args?.data?.objet ?? "");
                        titleElement.style.fontSize = '13px';
                    }*/

                   let formElement = args.element.querySelector('.e-schedule-form');


                    if (formElement) {
                        let existingRow = args.element.querySelector('.custom-field-container');
                        if (!existingRow) {
                            let container = document.createElement('div');
                            container.className = 'custom-field-container';
                            container.classList.add('fx-text-left');
                            let inputEleOrganisateur = document.createElement('input');
                            inputEleOrganisateur.className = 'e-field';
                            inputEleOrganisateur.setAttribute('name', 'Contact2Id');
                            inputEleOrganisateur.setAttribute('placeholder', self.organisateur_label);

                            let inputEleContact = document.createElement('input');
                            inputEleContact.className = 'e-field';
                            inputEleContact.setAttribute('name', 'ContactId');
                            inputEleContact.setAttribute('placeholder', self.contact_label);
                            //inputEleContact.setAttribute('aria-required', true); inputEleContact.setAttribute('required', true);

                                let multiSelectContacts = document.createElement('input');
                                    multiSelectContacts.className = 'e-field';
                                    multiSelectContacts.setAttribute('name', 'Contacts');
                                    multiSelectContacts.setAttribute('placeholder', self.participants_label);

                                    container.appendChild(inputEleOrganisateur);
                                    container.appendChild(inputEleContact);
                                    container.appendChild(multiSelectContacts);




                            // Ajoutez un gestionnaire d'événement pour la soumission du formulaire
                            formElement.addEventListener('submit', function(event) {
                                // Vérifiez si le champ "Contact" est vide
                                if (!inputEleContact.value) {
                                    // Empêchez la soumission du formulaire
                                    event.preventDefault();
                                    // Affichez un message d'erreur ou prenez toute autre action appropriée
                                    alert('Veuillez sélectionner un contact.');
                                }
                            });

                            // Faire une requête AJAX pour récupérer les options filtrées pour l'organisateur
                            await fetch(current_app + '/compte_rendus/get_organisateur_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour l'organisateur
                                    let drowDownListOrganisateur = new DropDownList({
                                        dataSource: formattedData,
                                        floatLabelType: 'Always',
                                        placeholder: self.organisateur_label,
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: args?.data?.Contact2Id || parseInt(self.contact2_id)
                                    });
                                  
                                    drowDownListOrganisateur.appendTo(inputEleOrganisateur);
                                    
                                    
                                    
                                                    let multiSelectObject = new MultiSelect({
                                                        dataSource: formattedData,
                                                        floatLabelType: 'Always',
                                                        placeholder: 'Select Contacts',
                                                        fields: {
                                                            text: 'text',
                                                            value: 'value'
                                                        },
                                                        value: args?.data?.Contacts || []
                                                    });
                                                    multiSelectObject.appendTo(multiSelectContacts);

                                })
                                .catch(error => console.error('Error fetching filtered options for Organisateur:', error));

                            // Faire une requête AJAX pour récupérer les options filtrées pour le contact
                            await fetch(current_app + '/compte_rendus/get_contact_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour le contact
                                    let drowDownListContact = new DropDownList({
                                        dataSource: formattedData,
                                        floatLabelType: 'Always',
                                        placeholder: self.contact_label,
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: args?.data?.ContactId,
                                    });
                                    drowDownListContact.appendTo(inputEleContact);
                                })
                                .catch(error => console.error('Error fetching filtered options for Contact:', error));

 
                            formElement.insertBefore(container, formElement.firstChild);
                        }
                    }
                }


               /* if (args.type === 'Editor') {
                    let formElement = args.element.querySelector('.e-schedule-form');
                    let titleElement = args.element.querySelector('[name="Subject"]');
                            if (titleElement) {
                                titleElement.setAttribute('required', 'true');
                                titleElement.style.fontSize = '13px';
                                let subjectElement = args.element.querySelector('[name="Subject"]');
                                if (subjectElement) {
                                  subjectElement.value = args?.data?.objet ?? "";
                               }
                         }
                    }


                    if (formElement && !args.element.querySelector('.custom-field-container')) {
                        let container = document.createElement('div');
                        container.className = 'custom-field-container fx-text-left';

                        let createInputElement = (name, placeholder, required) => {
                            let inputEle = document.createElement('input');
                            inputEle.className = 'e-field';
                            inputEle.setAttribute('name', name);
                            inputEle.setAttribute('placeholder', placeholder);
                            if (required) {
                                inputEle.required = true;
                            }
                            return inputEle;
                        };

                       let fetchAndPopulateDropDownList = async (url, inputElement, defaultValue) => {
                           try {
                               let response = await fetch(url);
                               let data = await response.json();
                               let formattedData = data.map(item => ({ text: item[0], id: item[1] }));

                               let dropDownList = new DropDownList({
                                   dataSource: formattedData,
                                   floatLabelType: 'Always',
                                   fields: { text: 'text', value: 'id' }, // Utilise l'ID comme valeur sélectionnée
                                   value: defaultValue
                               });
                               dropDownList.appendTo(inputElement);
                           } catch (error) {
                               console.error('Error fetching or populating dropdown list:', error);
                           }
                       };


                        let inputEleOrganisateur = createInputElement('Contact2Id', self.organisateur_label, true);
                        let inputEleContact = createInputElement('ContactId', self.contact_label, true);

                        container.appendChild(inputEleOrganisateur);
                        container.appendChild(inputEleContact);

                        formElement.insertBefore(container, formElement.firstChild);

                        // Fetch and populate dropdown lists asynchronously
                        fetchAndPopulateDropDownList(current_app + '/compte_rendus/get_organisateur_list', inputEleOrganisateur, args?.data?.Contact2Id || parseInt(self.contact2_id));
                        fetchAndPopulateDropDownList(current_app + '/compte_rendus/get_contact_list', inputEleContact, args?.data?.ContactId);
                    }
                }*/


                if (args.type === 'QuickInfo') {
                    // Créer les éléments personnalisés requis lors de l'ouverture de QuickInfo
                    //args.element.querySelector('.e-subject').setAttribute('name', 'Object');
                    let formElement = args.element.querySelector('.e-schedule-form');
                    let titleElement = args.element.querySelector('.e-subject');
                    if (titleElement) {
                        titleElement.setAttribute('required', 'true');
                        titleElement.setAttribute('value', args?.data?.objet ?? "");
                        titleElement.style.fontSize = '13px';
                    }
                    if (formElement) {
                        let existingRow = args.element.querySelector('.custom-field-container');
                        if (!existingRow) {
                            // let row = document.createElement('div');
                            //row.className = 'custom-field-row';


                            let container = document.createElement('div');
                            container.className = 'custom-field-container';
                            container.classList.add('fx-text-left');

                            let inputEleOrganisateur = document.createElement('infput');
                            inputEleOrganisateur.className = 'e-field';
                            inputEleOrganisateur.setAttribute('name', 'Contact2Id');
                            inputEleOrganisateur.setAttribute('placeholder', self.organisateur_label);

                            let inputEleContact = document.createElement('input');
                            inputEleContact.className = 'e-field';
                            inputEleContact.setAttribute('name', 'ContactId');
                            inputEleContact.setAttribute('placeholder', self.contact_label);
                            //inputEleContact.setAttribute('aria-required', true); inputEleContact.setAttribute('required', true);
                            container.appendChild(inputEleOrganisateur);
                            container.appendChild(inputEleContact);
                            //row.appendChild(container);
                            let nextDivElement = container.nextElementSibling;
                            if (nextDivElement) {
                                nextDivElement.className = "custom-field-container e-control-wrapper e-ddl e-float-input e-input-group e-keyboard e-lib e-valid-input"
                            }

                            // Faire une requête AJAX pour récupérer les options filtrées pour l'organisateur
                            await fetch(current_app + '/compte_rendus/get_organisateur_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour l'organisateur
                                    let drowDownListOrganisateur = new DropDownList({
                                        dataSource: formattedData,
                                        placeholder: self.organisateur_label,
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: parseInt(self.contact2_id)
                                    });
                                    drowDownListOrganisateur.appendTo(inputEleOrganisateur);

                                })
                                .catch(error => console.error('Error fetching filtered options for Organisateur:', error));

                            // Faire une requête AJAX pour récupérer les options filtrées pour le contact
                            await fetch(current_app + '/compte_rendus/get_contact_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour le contact
                                    let drowDownListContact = new DropDownList({
                                        dataSource: formattedData,
                                        placeholder: self.contact_label,
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: args?.data?.ContactId,
                                    });
                                    drowDownListContact.appendTo(inputEleContact);
                                })
                                .catch(error => console.error('Error fetching filtered options for Contact:', error));


                            formElement.appendChild(container);
                        }
                    }
                }

            }

        });
        if (schedulerElement && schedulerElement.children.length > 2) {
            console.log("La barre d'outils du calendrier est déjà initialisée !");

            // Supprimer tous les enfants de schedulerElement sauf ceux avec les IDs spécifiés
            /*    Array.from(schedulerElement.children).forEach(child => {
                   if (child.id !== "filterrific_filter" && child.id !== "event_refresh") {
                       schedulerElement.removeChild(child);
                   }
               });  */



            console.log("schedulerElement ", schedulerElement);
            console.log("schedulerElement.children.length ", schedulerElement?.children?.length);
            console.log("schedulerElement.children ", schedulerElement?.children);

        } else {
            console.log("La barre d'outils du calendrier est initialisée !");
            scheduler.appendTo(schedulerElement);


            // Afficher l'indicateur de chargement
            scheduler.showSpinner();

            // Simuler une opération asynchrone (par exemple, une requête AJAX)
            setTimeout(function() {
                // Ici, vous pouvez effectuer votre traitement asynchrone, par exemple, une requête AJAX
                // Une fois que le traitement asynchrone est terminé, vous pouvez masquer l'indicateur de chargement
                scheduler.hideSpinner(); // Masquer l'indicateur de chargement
            }, 10000); // Dans cet exemple, j'ai mis une temporisation de 2 secondes pour simuler un traitement asynchrone
        }



        return scheduler;


    }




    get current_app() {
        return this.data.get("app");
    }

    get contact2_id() {
        return this.data.get("contact2id");
    }
    get local() {
        return this.data.get("local");
    }

    get params() {
        return this.data.get("params");
    }

    get compte_rendu_id() {
        return this.data.get("compte_renduid");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }

    get contact_label() {
        return this.data.get("contactlabel");
    }

    get participants_label() {
        return this.data.get("participantslabel");
    }

    get organisateur_label() {
        return this.data.get("organisateurlabel");
    }
}